import { RegistryContext } from "@effect/atom-react";
import { AtomRegistry } from "effect/unstable/reactivity";

export let appAtomRegistry = AtomRegistry.make();

type AppAtomRegistryProviderChildren = React.ComponentProps<
  typeof RegistryContext.Provider
>["children"];

export function AppAtomRegistryProvider({
  children,
}: {
  readonly children: AppAtomRegistryProviderChildren;
}) {
  return <RegistryContext.Provider value={appAtomRegistry}>{children}</RegistryContext.Provider>;
}

export function resetAppAtomRegistryForTests() {
  appAtomRegistry.dispose();
  appAtomRegistry = AtomRegistry.make();
}
